{
  "app": {
    "version": "Version {{version}} · Light Business Management"
  },
  "actions": {
    "label": "Actions",
    "close": "Close",
    "cancel": "Cancel",
    "save": "Save",
    "edit": "Edit",
    "delete": "Delete",
    "done": "Done",
    "undo": "Undo",
    "signOut": "Sign out",
    "backHome": "Back to home"
  },
  "nav": {
    "label": "Main navigation",
    "home": "Home",
    "stockInOut": "Stock in & out",
    "transfers": "Transfers",
    "counts": "Inventory counts",
    "orders": "Orders",
    "customers": "Customers",
    "stockLevels": "Stock levels",
    "products": "Products",
    "locations": "Locations",
    "reports": "Reports",
    "activity": "Activity log",
    "alerts": "Alerts",
    "company": "Company",
    "configuration": "Configuration",
    "users": "Users & roles",
    "dataTools": "Data tools",
    "help": "Help & user guide",
    "profile": "My profile",
    "menu": "Menu",
    "sections": {
      "daily": "Daily work",
      "sales": "Sales",
      "stock": "Stock",
      "followUp": "Follow-up",
      "admin": "Administration",
      "purchases": "Purchases"
    },
    "payments": "Payments",
    "registers": "Cash registers",
    "pos": "Point of sale",
    "categories": "Categories",
    "brands": "Brands",
    "suppliers": "Suppliers",
    "supplierPayments": "Supplier payments",
    "documents": "Documents",
    "promotions": "Promotions",
    "onlineStore": "Online store",
    "stockLimits": "Stock limits"
  },
  "time": {
    "today": "Today",
    "yesterday": "Yesterday"
  },
  "search": {
    "label": "Search",
    "placeholder": "Search a product, SKU, barcode or document number",
    "scan": "Scan a barcode",
    "scanShort": "Scan",
    "scanHint": "Barcode scanners type into the search field: scan, and the result opens.",
    "results": "Search results",
    "noResults": "No result for “{{query}}”.",
    "phaseHint": "Products, documents, people and locations. Scan a barcode to open its product.",
    "types": {
      "user": "Person",
      "location": "Location",
      "product": "Product",
      "document": "Document",
      "customer": "Customer",
      "supplier": "Supplier"
    },
    "documentTypes": {
      "stockIn": "Stock in",
      "stockOut": "Stock out",
      "adjustment": "Adjustment",
      "openingStock": "Opening stock",
      "transfer": "Transfer",
      "count": "Count"
    }
  },
  "locations": {
    "all": "All locations",
    "allLower": "all locations",
    "none": "No location yet"
  },
  "operations": {
    "new": "New operation",
    "receive": {
      "title": "Receive stock",
      "text": "Goods arrived from a supplier or another source"
    },
    "issue": {
      "title": "Issue stock",
      "text": "A sale, a use or a consumption"
    },
    "move": {
      "title": "Move stock",
      "text": "Transfer between two locations"
    },
    "count": {
      "title": "Count stock",
      "text": "Check the shelves against the system"
    },
    "correct": {
      "title": "Correct stock",
      "text": "Damaged, lost or found items"
    },
    "opening": {
      "title": "Opening stock",
      "text": "Quantities and costs you already have when starting"
    }
  },
  "language": {
    "label": "Language"
  },
  "roles": {
    "admin": "Administrator",
    "manager": "Manager",
    "storekeeper": "Storekeeper",
    "cashier": "Cashier",
    "viewer": "Viewer"
  },
  "feedback": {
    "forbiddenTitle": "This page is not for your role",
    "forbiddenText": "Your role does not give access to this area. Ask an administrator if you need it.",
    "notFoundTitle": "Page not found",
    "notFoundText": "The address may be wrong, or the page has moved."
  },
  "breadcrumb": "Breadcrumb",
  "pagination": {
    "label": "Pages",
    "previous": "Previous page",
    "next": "Next page",
    "pageSize": "Rows per page",
    "perPage_one": "{{count}} per page",
    "perPage_other": "{{count}} per page"
  },
  "locationTypes": {
    "warehouse": "Warehouse",
    "store": "Store",
    "depot": "Depot",
    "zone": "Zone",
    "shelf": "Shelf",
    "bin": "Bin",
    "transit": "In transit"
  },
  "attachments": {
    "title": "Attachments",
    "subtitle": "PDF or images, up to {{size}} each.",
    "emptyReadOnly": "No file attached.",
    "saveFirst": "Files can be attached once the draft is saved.",
    "drop": "Drop files here, or",
    "choose": "Choose files",
    "photo": "Take a photo",
    "uploading": "Sending {{name}}...",
    "open": "Open {{name}}",
    "removeOne": "Remove {{name}}",
    "remove": "Remove",
    "removeTitle": "Remove {{name}}?",
    "removeText": "The file is removed for everyone. The activity log keeps a trace of it.",
    "removed": "File removed",
    "tooLarge": "{{name}} is larger than {{size}}.",
    "wrongType": "{{name}} is not a PDF or an image (JPEG, PNG, WebP).",
    "emptyOperation": "No file attached yet: an invoice, a delivery note, a photo...",
    "emptyProduct": "No file attached yet: a datasheet, a certificate, a photo...",
    "kb": "{{value}} KB",
    "mb": "{{value}} MB",
    "emptySupplierPayment": "No file attached yet: a receipt, a transfer slip, a photo of the cheque..."
  },
  "commerce": {
    "percent": "{{value}}%",
    "priceSplit": "Excl. VAT {{net}} · VAT {{rate}} {{tax}} TND",
    "channelTypes": {
      "pos": "Counter",
      "online": "Online",
      "backOffice": "Back office"
    },
    "paymentMethods": {
      "cash": "Cash",
      "card": "Card",
      "cheque": "Cheque",
      "transfer": "Bank transfer",
      "cashOnDelivery": "Cash on delivery",
      "payAtPickup": "Pay at pickup",
      "online": "Online payment"
    },
    "deliveryModes": {
      "shipping": "Shipping",
      "pickup": "Pickup"
    },
    "steps": {
      "picking": "Picking",
      "packing": "Packing"
    }
  },
  "maintenance": {
    "title": "The data is being restored",
    "text": "The app is closed for a moment while a backup is brought back. It opens again by itself; then sign in again.",
    "waiting": "Please wait...",
    "steps": {
      "checking": "Checking the backup...",
      "safety": "Saving the current data first...",
      "database": "Bringing the data back...",
      "files": "Bringing the files back...",
      "finishing": "Finishing..."
    }
  },
  "help": {
    "print": "Print",
    "contents": "Contents"
  },
  "camera": {
    "open": "Scan with the camera",
    "title": "Scan a barcode",
    "starting": "Opening the camera…",
    "aim": "Point the camera at a barcode.",
    "read": "Read: {{code}}. Next one?",
    "light": "Light",
    "switch": "Switch camera",
    "done": "Done",
    "retry": "Try again",
    "problems": {
      "denied": {
        "title": "Camera access was refused",
        "text": "Allow the camera for this site in the browser’s settings, then try again."
      },
      "noCamera": {
        "title": "No camera found",
        "text": "Use a phone or a tablet, or type the code."
      },
      "busy": {
        "title": "The camera is in use",
        "text": "Close the other app that uses it, then try again."
      },
      "failed": {
        "title": "The camera could not start",
        "text": "Try again. If it keeps failing, type the code or use a scanner."
      }
    }
  }
}
